export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              关于我们
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-4">
              黑料网站是国内领先的娱乐八卦资讯聚合平台，致力于为吃瓜群众提供最新、最全、最可靠的黑料爆料内容。
            </p>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-6">
              我们拥有一支专业的编辑团队，全天候追踪娱乐圈、网红圈、直播圈等各大领域的最新动态。
              平台覆盖黑料网在线观看、吃瓜黑料在线、51黑料在线观看等热门频道，
              月均服务超过八千万用户，是国内最大的吃瓜内容社区之一。
              我们坚持真实、客观、及时的报道原则，同时严格保护爆料人隐私与合法权益。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6">
              <div className="text-center">
                <p className="text-xl md:text-2xl font-heading font-bold text-primary-600">3年</p>
                <p className="text-xs text-foreground-500">稳定运营</p>
              </div>
              <div className="text-center">
                <p className="text-xl md:text-2xl font-heading font-bold text-accent-600">50+</p>
                <p className="text-xs text-foreground-500">编辑团队</p>
              </div>
              <div className="text-center">
                <p className="text-xl md:text-2xl font-heading font-bold text-primary-600">99.9%</p>
                <p className="text-xs text-foreground-500">服务可用率</p>
              </div>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-[400px] lg:max-w-[440px]">
            <div className="aspect-[4/3] rounded-xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20team%20collaboration%20concept%20with%20warm%20crimson%20and%20charcoal%20tones%2C%20modern%20minimalist%20office%20atmosphere%2C%20clean%20professional%20aesthetic%2C%20newsroom%20style%20composition%2C%20soft%20lighting%2C%20creative%20workspace%20vibe&width=880&height=660&seq=about-image&orientation=landscape"
                alt="黑料网站编辑团队"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}